import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ab877c8a313271bc5228e0c078957bae8b from "./generated-e0aeb86c-cbdb-487b-b52c-b8479e2e3ab3.json";

import ad9776222391759ab1c95003194ab73c4b from "./generated-20020cda-db93-46eb-8b52-09c4c822872c.json";

import a6b28d7bc3b11dd8e8701fc46f9393a08b from "./generated-6139f932-3520-46b5-96eb-4900a6025a35.json";

import a3b45e58fe37abf339654dcb2d5956dd5b from "./generated-7cb96efa-95f5-42b7-a5a8-52e440332dc6.json";

import ad27284c0e49b511ec238cd6dd8e6e6f0b from "./generated-9b22bf17-c0da-48ee-bd8d-10d2f1f0a116.json";

import a56418b72bbe71f10a293631a6611a1b8b from "./generated-34700849-cb7e-4c03-a702-747df5beb195.json";

import a40ed69cfe4c5e2261e883d1fa25a183eb from "./generated-a1360a71-8143-4a0f-af59-070821c5e0c3.json";

import ab12b1bd1a569b070b8db8c113fd0e91ab from "./generated-2a2dd5d0-ef64-47e9-b5ab-6087f6169852.json";

import a8438655921c5201a75d52f31102d5ad9b from "./generated-d3de1191-8284-44d7-8dc3-8d399561cf6f.json";

import a5c6367d4f78657407c1d424cb26f07c9b from "./generated-55672665-4621-4204-9528-0d385caba1c2.json";

import a9e7ad74172e6a509c4b33c59b87d29ddb from "./generated-3753b872-66e2-4ae3-8693-eb8ee03ceb5c.json";

import a0544cd762b330877a380d0fd5c410f99b from "./generated-886dcc6a-6892-4edc-8b33-f9eb96795b25.json";

import aab94bfe01d2e6c4aaf1b3cc7ca009967b from "./generated-32d87196-82b1-455f-b46a-c2895bdc6d70.json";

import a996564eb886c327c244dcfba649ec6b6b from "./generated-58f91563-c0f8-430a-ba18-94e279b90106.json";

import ab5e9a291b6995beda9dc6f27aa9fd28fb from "./generated-a0d6e009-4ebf-4b5c-9d9b-701420e4ca02.json";

import a4574b133ba59d5acedbfadabc6b3d8cbb from "./generated-c76bdaec-339a-4f3c-9bd7-961cce20da00.json";

import a96886cb7870a3b2c8dc22cf3d9b6da20b from "./generated-aff9c330-d13b-40fa-9c5a-ee6ff50aab2a.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ab877c8a313271bc5228e0c078957bae8b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ad9776222391759ab1c95003194ab73c4b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a6b28d7bc3b11dd8e8701fc46f9393a08b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a3b45e58fe37abf339654dcb2d5956dd5b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ad27284c0e49b511ec238cd6dd8e6e6f0b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a56418b72bbe71f10a293631a6611a1b8b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a40ed69cfe4c5e2261e883d1fa25a183eb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ab12b1bd1a569b070b8db8c113fd0e91ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a8438655921c5201a75d52f31102d5ad9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a5c6367d4f78657407c1d424cb26f07c9b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a9e7ad74172e6a509c4b33c59b87d29ddb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a0544cd762b330877a380d0fd5c410f99b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a8438655921c5201a75d52f31102d5ad9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aab94bfe01d2e6c4aaf1b3cc7ca009967b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a996564eb886c327c244dcfba649ec6b6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a8438655921c5201a75d52f31102d5ad9b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ab5e9a291b6995beda9dc6f27aa9fd28fb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a4574b133ba59d5acedbfadabc6b3d8cbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a96886cb7870a3b2c8dc22cf3d9b6da20b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ab5e9a291b6995beda9dc6f27aa9fd28fb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */